<sgt-multi-select
  [options]="options"
  [settings]="settings"
  [variante]="variante"
  [icon]="icon"
  [(ngModel)]="idsCadastros"
  (ngModelChange)="onSelectionChange()"
  (search)="onSelected()"
>
</sgt-multi-select>
